// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueGtag from "vue-gtag";
import VueGtm from "@gtm-support/vue2-gtm";
import vueCookies from "vue-cookies";

const App = () =>
	import(/* webpackChunkName: "component-app" */ "@/components/app");
import router from "@/router";
import store from "@/store";
import i18n from "@/common/multilanguage/i18n";
import { GTAG_CONFIG, STAGE, getExcoPlayerId } from "@/common/consts";
import { isFeatureEnabled } from "@/common/feature-toggling";
import nodeConfig from "../package.json";
import {
	initAnalytics,
	trackCLS,
	trackFID,
	trackLCP,
	trackFCP,
} from "@lovetoknow/ltk-analytics";

import "./mixins";

if (typeof window.__PRERENDER_INJECTED === "undefined") {
	Vue.use(VueGtag, GTAG_CONFIG, router);

	const analytics = initAnalytics({
		appName: "wscapes",
		appEnvironment: STAGE,
		expTrack: true,
		pageTrack: true,
		version: nodeConfig.version,
		debug: isFeatureEnabled("debugCoreVitals"),
		meta_url:
			"https://us-central1-custom-site-analytics.cloudfunctions.net/router/metaInfo",
		page_exp_url:
			"https://us-central1-custom-site-analytics.cloudfunctions.net/router/pageExp",
		page_evt_url:
			"https://us-central1-custom-site-analytics.cloudfunctions.net/router/pageEvt",
		custom_evt_url:
			"https://us-central1-custom-site-analytics.cloudfunctions.net/router/customEvt",
	});
	window.$ltkAnalytics = analytics;

	if (isFeatureEnabled("trackCoreVitals")) {
		trackCLS();
		trackFID();
		trackLCP();
		trackFCP();
	}
}

Vue.use(vueCookies);

if (
	typeof window.__PRERENDER_INJECTED === "undefined" &&
	typeof window.__TEST__ === "undefined"
) {
	Vue.use(VueGtm, {
		id: "GTM-5SVHM3B",
		debug: isFeatureEnabled("debugGTM"),
		vueRouter: router,
	});

	var loadAditude = function() {
		// Begin Aditude code
		var id = "ws_aditude";
		if (document.getElementById(id)) {
			console.log("+++ Aditude script already loaded.");
			return;
		}
		var s = document.createElement("script");
		s.async = true;
		s.src =
			"https://dn0qt3r0xannq.cloudfront.net/lovetoknow-1r2kdxaraW/wordscapes/prebid-load.js";
		s.id = id;
		var firstScript = document.getElementsByTagName("script")[0];
		firstScript.parentNode.insertBefore(s, firstScript);
		console.log("+++ Aditude script loaded.");
		// End Aditude code
	};

	// Begin EX.CO code (WFW-6716)
	// Injects the EX.CO player script alongside Aditude on ad consent. The
	// script is added with programmatic="true" so the player does not
	// auto-start; the ExcoAdvertisement component drives init() itself.
	var loadExco = function() {
		if (isFeatureEnabled("DisableThirdParty")) {
			return;
		}

		window.dataLayer = window.dataLayer || [];
		if (window.dataLayer.__excoLoaded) {
			return;
		}

		var js = document.createElement("script");
		js.className = "exco-player";
		js.setAttribute("programmatic", "true");
		js.onload = function() {
			store.commit("ads/SET_IS_EXCO_LOADED", true);
		};
		js.src = "//player.ex.co/player/" + getExcoPlayerId();
		var firstExcoScript = document.getElementsByTagName("script")[0];
		firstExcoScript.parentNode.insertBefore(js, firstExcoScript);

		window.dataLayer.__excoLoaded = true;
		console.log("+++ EX.CO script loaded.");
	};
	// End EX.CO code

	if (window.__consent_loaded === true) {
		loadAditude();
		loadExco();
	}

	window.addEventListener("consent_loaded", () => {
		loadAditude();
		loadExco();
	});
}

/* eslint-disable no-new */
new Vue({
	el: "#app",
	i18n,
	router,
	store,
	components: { App },
	template: "<App/>",
	metaInfo: {
		script: [
			{
				vmid: "jsonld-organization",
				type: "application/ld+json",
				json: {
					"@context": "https://schema.org",
					"@type": "Organization",
					name: "Wordscapes by YourDictionary",
					url: "https://wordscapes.yourdictionary.com",
					logo:
						"https://wordscapes.yourdictionary.com/static/images/logo_horizontal.png",
					address: {
						"@type": "PostalAddress",
						addressLocality: "Vero Beach, FL",
						postalCode: "32960-4706",
						streetAddress: "1275 US Highway 1 Unit 2-6084",
					},
					parentOrganization: {
						"@type": "Organization",
						"@id": "https://www.lovetoknowmedia.com/",
						name: "LoveToKnow Media",
						url: "https://www.lovetoknowmedia.com/",
						sameAs: [
							"https://www.linkedin.com/company/lovetoknowmedia/",
							"https://www.instagram.com/lovetoknowmedia/",
							"https://www.facebook.com/lovetoknowmedia/about",
							"https://x.com/lovetoknowmedia",
							"https://www.crunchbase.com/organization/lovetoknow-corp",
						],
						logo: {
							"@type": "ImageObject",
							url:
								"https://www.lovetoknowmedia.com/wp-content/uploads/2021/05/LTK_MEDIA_Logo-2.png",
						},
						address: {
							"@type": "PostalAddress",
							addressLocality: "Vero Beach, FL",
							postalCode: "32960-4706",
							streetAddress: "1275 US Highway 1 Unit 2-6084",
						},
					},
				},
			},
		],
	},
});
